import { useMutation } from '@tanstack/solid-query';
import { whatsappGraphql } from './client';

export interface WhatsappBroadcastStarted {
  accountId: string;
  total: number;
  skipped: number;
}

const BROADCAST = `mutation WhatsappBroadcast($accountId: String!, $recipients: [String!]!, $text: String!) {
  whatsappBroadcast(accountId: $accountId, recipients: $recipients, text: $text) {
    accountId
    total
    skipped
  }
}`;

/** Mass-send (群发) a message to many recipients from one account. */
export function useBroadcastMutation() {
  return useMutation(() => ({
    gcTime: 0,
    mutationFn: async (vars: {
      accountId: string;
      recipients: string[];
      text: string;
    }) => {
      const data = await whatsappGraphql<{
        whatsappBroadcast: WhatsappBroadcastStarted;
      }>(BROADCAST, vars);
      return data.whatsappBroadcast;
    },
  }));
}
